/**
 * EngagementIcon — Mi6 custom glyph: handshake
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function EngagementIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Left arm reaching right */}
      <path
        d="M8 44 L18 38 L26 40 L34 36"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Right arm reaching left */}
      <path
        d="M72 44 L62 38 L54 40 L46 36"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Clasped hands at center */}
      <path
        d="M34 36 C36 33 40 33 40 36 C40 33 44 33 46 36"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Knuckle ridge */}
      <path
        d="M32 38 C34 40 36 41 40 40 C44 41 46 40 48 38"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Finger outlines left hand */}
      <path d="M26 40 L24 48 L30 50 L34 42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <line x1="28" y1="44" x2="30" y2="48" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
      {/* Finger outlines right hand */}
      <path d="M54 40 L56 48 L50 50 L46 42" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <line x1="52" y1="44" x2="50" y2="48" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.6" />
      {/* Sleeve cuffs */}
      <line x1="16" y1="36" x2="20" y2="44" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="64" y1="36" x2="60" y2="44" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
